import { Link } from 'react-router-dom';

import stringUtils from '../utils/stringUtils';
import ListView from '../Common/Views/ListView';

import { Chip } from '@mui/material';

// Direction icons
import OutIcon from '@mui/icons-material/ArrowBack';
import InIcon from '@mui/icons-material/ArrowForward';

const PaymentAllocationsList = ({
    filters = {},
    addButton = false,
    onSelect = () => {}, // a function to override the table row click action (default is to navigate to details page)
    columns = null, // array if specific columns from the columnsConfig to show in the list view. If null, all columns will be shown.
    noResultsMessage = "No payment allocations found"
}) => {

    const displayDirection = (direction) => {
        if (direction === 'IN') {
            return <><InIcon fontSize="small" style={{ verticalAlign: 'middle', color: 'green' }} /> IN</>;
        }
        if (direction === 'OUT') {
            return <><OutIcon fontSize="small" style={{ verticalAlign: 'middle', color: 'red' }} /> OUT</>;
        }
        return 'N/A';
    }

    const displayPayableId = (payableType, payableId) => {
        // For better readability, show only the last part of the ID
        const displayId = payableId?.substring(payableId.lastIndexOf("-") + 1).toUpperCase() || 'N/A'

        // Generate a clickable link based on payable type
        let link = '#';
        switch (payableType) {
            case 'INVOICE':
                link = `/sales/invoices/${payableId}`;
                break;
            // Add more cases as needed for different payable types
            default:
                link = '#';
        }

        return <Link to={link}>{displayId}</Link>;
    }

    const displayPaymentId = (paymentId) => {
        // For better readability, show only the last part of the ID
        const displayId = paymentId?.substring(paymentId.lastIndexOf("-") + 1).toUpperCase() || 'N/A'
        return <Link to={`/payments/${paymentId}`}>{displayId}</Link>;
    }

    const displayStatus = (status) => {
        switch (status) {
            case 'ON_HOLD':
                return <Chip label="On Hold" color="warning" size="small" />;
            case 'APPLIED':
                return <Chip label="Applied" color="success" size="small" />;
            case 'CANCELLED':
                return <Chip label="Cancelled" color="error" size="small" />;
            default:
                return <Chip label="Unknown" size="small" />;
        }
    }

    // Columns configuration for rendering payment allocations list
    const columnsConfig = {
        payableType: {
            key: 'payableType',
            label: 'Payable Type',
            render: row => row.payableType
        },
        payableId: {
            key: 'payableId',
            label: 'Payable ID',
            render: row => displayPayableId(row.payableType, row.payableId)
        },
        amount: {
            key: 'amount',
            label: 'Amount',
            render: row => `${stringUtils.formatPriceWithCommas(row.amount)}`
        },
        status: {
            key: 'status',
            label: 'Status',
            render: row => displayStatus(row.status)
        },
        createdAt: {
            key: 'createdAt',
            label: 'Created At',
            render: row => row.createdAt ? stringUtils.isoToLocalDateTime(row.createdAt) : 'N/A'
        },
        appliedAt: {
            key: 'appliedAt',
            label: 'Applied At',
            render: row => row.appliedAt ? stringUtils.isoToLocalDateTime(row.appliedAt) : 'N/A'
        },
        paymentId: {
            key: 'paymentId',
            label: 'Payment ID',
            render: row => displayPaymentId(row.paymentId)
        }
    };

    return <ListView
        title="Payment Allocations"
        apiPath="/tenants/payments/allocations"
        filters={filters}
        addButton={false}
        // addButtonLabel="Record new payment"
        // addPath="/payments/add"
        rowClickPath={(item) => `/payments/${item.id}`}
        onSelect={onSelect}
        columnsConfig={columnsConfig}
        columns={columns}
        // searchAttributes={[
        //     { name: "Name", value: "name" },
        //     { name: "Type", value: "type" },
        // ]}
        noResultsMessage={noResultsMessage}
    />
};

export default PaymentAllocationsList;